import { createContext } from 'react';

const matchContext = createContext();

export default matchContext;